<template>
    <div>
        <b-button-group size="sm" class="w-100 table-actions">
            <!-- Кнопка "Оценка" для агентов -->
            <b-button
                variant="primary"
                v-if="checkActionAllow('evaluation')"
                @click="openEvaluationModal(row.index)"
                title="Оценка клиента"
            >
                Оценить <i class="fas fa-star text-warning"></i>
            </b-button>
            
            <!-- Кнопка "Удалить" для остальных ролей -->
            <b-button
                variant="danger"
                v-if="checkActionAllow('delete')"
                @click="deleteItem(row.index)"
                title="Удалить"
            >
                Удалить <i class="fas fa-trash text-danger"></i>
            </b-button>
        </b-button-group>
    </div>
</template>

<script>
    import {
        checkActionAllow
    } from '@/mixins'

    export default {
        props: {
            row: {type: Object, required: true},                                                // Row of table
            actionAllows: {type: Array, required: false, default: function () { return [] }},   // Array of rules for action allows
        },
        mixins: [
            checkActionAllow
        ],
        methods: {
            // Открыть модальное окно оценки
            openEvaluationModal(index) {
                this.$emit('universalEmit', 'evaluation', index)
            },
            
            // Удалить элемент
            deleteItem(index) {
                this.$emit('universalEmit', 'delete', index)
            }
        }
    }
</script>

<style scoped>
.btn-group .btn {
    min-width: 32px;
}
</style>

